<template>
    <v-app id="app">
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
    </v-app>
</template>

<script>
    export default {
        mounted() {
            this.applyThemeMode();

            window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
                if ((localStorage.themeMode || 'system') === 'system') {
                    this.$vuetify.theme.dark = e.matches;
                }
            });
        },
        methods: {
            applyThemeMode() {
                const themeMode = localStorage.themeMode || 'system';

                if (themeMode === 'dark') {
                    this.$vuetify.theme.dark = true;
                    return;
                }

                if (themeMode === 'light') {
                    this.$vuetify.theme.dark = false;
                    return;
                }

                this.$vuetify.theme.dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            }
        }
    }
</script>
